<script setup lang="ts">
import { computed, inject } from 'vue'
import type { ExpressionServiceModel } from '@/types'
import type { ScopeDescriptor } from '@/types/bbel-types'
import AdvancedSettings from './AdvancedSettings.vue'
import BbelField from '@/views/builder/components/bbel/BbelField.vue'
import { BBEL_SCOPE_KEY, EMPTY_BBEL_SCOPE, type BbelScopeContext } from '@/views/builder/composables/bbel-context'

const props = defineProps<{
  modelValue: ExpressionServiceModel
}>()

const emit = defineEmits<{
  'update:modelValue': [value: ExpressionServiceModel]
}>()

// Scope is provided by BuilderView; empty in read-only hosts (highlighting only, no suggestions).
const bbelScopeCtx = inject<BbelScopeContext | undefined>(BBEL_SCOPE_KEY, undefined)
const scope = computed<ScopeDescriptor>(() => bbelScopeCtx?.value ?? EMPTY_BBEL_SCOPE)

const expression = computed({
  get: () => props.modelValue.expression ?? '',
  set: (value: string) => emit('update:modelValue', { ...props.modelValue, expression: value }),
})
</script>

<template>
  <div class="mb-3">
    <label class="form-label">Expression</label>
    <BbelField
      v-model="expression"
      :scope="scope"
      lang="text"
      field-shape="body"
      placeholder="Text with {{ }} expressions — e.g. Hello {{ wizard.firstName }}"
    />
    <div class="form-text">
      Type <code v-pre>{{</code> to autocomplete values and functions.
    </div>
    <AdvancedSettings />
  </div>
</template>
